'use client';

import { useUserEventLogger } from '@repo/tracking-service';
import { Divider, List, Svg } from '@repo/ui';
import { useRouter } from 'next/navigation';

const ListArrowIcon = <Svg src={'ic_chevron-right.svg'} width={20} height={20} className={'block'} color={'#8A96A3'} />;

export const ContentFooter = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  return (
    <div className={'pb-normal-medium'}>
      <Divider className={'bg-neutral-border-main mt-spacious-small mb-normal-xlarge'} />
      <List
        leadingElement={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_house_md.svg`} width={32} height={32} alt="홈" />}
        title={'홈으로'}
        description={'전문가들이 검증한 다른 콘텐츠 보기'}
        supportingElement={ListArrowIcon}
        primaryAction
        onClick={() => {
          sendClickEvent('direction-to_home', { location: 'bottom', page: 'contents' });
          router.push('/');
        }}
      />
    </div>
  );
};
